export default __webpack_public_path__ + "static/media/KheshattaOasis.c5885474.jpg";